const isScrollingDown = ref(false);
const oldScroll = ref();
const setOldScrollTimeout = ref();

export default () => {
	const scrollDelayBoundary = 100;

	function setScrollDirection() {
		clearTimeout(setOldScrollTimeout.value);

		isScrollingDown.value
            = window.scrollY > scrollDelayBoundary
				? oldScroll.value < window.scrollY
				: false;

		setOldScrollTimeout.value = setTimeout(() => {
			oldScroll.value = window.scrollY;
		}, 10);
	}

	onMounted(() => {
		window.addEventListener('scroll', setScrollDirection);
	});

	onUnmounted(() => {
		window.removeEventListener('scroll', setScrollDirection);
	});

	return {
		isScrollingDown,
	};
};
